import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const AppThemePreset = definePreset(Lara, {
  semantic: {}
});

export default AppThemePreset;
